import React from 'react';
import block from 'bem-cn-lite';

import {NavigationItemExtended, ServiceData} from 'models/app';
import {NavigationSectionType} from 'units/navigation/models';
import ServiceTag from 'units/constructor-local/components/ServiceTag/ServiceTag';

interface TagProps {
    item: NavigationItemExtended;
    type: NavigationSectionType;
    tagProps?: {
        size?: 's' | 'm';
    };
}

const b = block('navigation-tag');

const Tag: React.FC<TagProps> = ({item, type, tagProps}) => {
    if (type === NavigationSectionType.Services) {
        const {status, tag} = item as ServiceData;

        if (status && tag) {
            return <ServiceTag className={b('tag')} tag={tag} status={status} {...tagProps} />;
        }
    }

    return null;
};
export default Tag;
